
import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  onMounted,
  PropType,
  Ref
} from "vue";
import { useToast } from "../../../modules/message";
import { ClientePayload } from "../../../modules/business/cliente/clienteBusiness";
import {
  PessoaAnttPayload,
  usePessoaAnttService
} from "../../../modules/business/rntrc/pessoa/pessoaAnttBusiness";
import { formatCpfCnpj } from "../../../modules/business/rntrc/rntrcTypes";

/** Menos que isso, a API nem busca (traria a base inteira). */
const MINIMO_BUSCA = 3;

interface BuscaPessoaAnttState {
  termo: string;
  resultados: Array<PessoaAnttPayload>;
  buscou: boolean;
  stateReady: boolean;
  stateId: string;
  loadings: Array<Ref<boolean>>;
}

/**
 * Lupa do transportador nas telas de serviço: busca na base do próprio cliente (cadastro da
 * ANTT e transportadores da GovPass) quem já foi atendido, para não cadastrar de novo.
 */
export default defineComponent({
  setup(props, { emit }) {
    const state = reactive<BuscaPessoaAnttState>({
      termo: "",
      resultados: [],
      buscou: false,
      stateReady: false,
      stateId:
        "state-" +
        Math.random()
          .toString(36)
          .substring(2),
      loadings: []
    });

    const stateLoading = computed(
      () => state.loadings.length !== 0 || !!props.parentLoading
    );

    const papelMinusculo = computed(() =>
      (props.papel || "transportador").toLowerCase()
    );

    const titulo = computed(() => "Buscar " + papelMinusculo.value);

    const removeLoading = (loading: Ref<boolean>) => {
      const idx = state.loadings.indexOf(loading);
      if (idx >= 0) {
        state.loadings.splice(idx, 1);
      }
    };

    const buscar = () => {
      const termo = (state.termo ?? "").trim();
      if (termo.length < MINIMO_BUSCA) {
        useToast().warning(
          "Digite pelo menos " +
            MINIMO_BUSCA +
            " letras do nome ou números do CPF/CNPJ."
        );
        return;
      }
      const {
        data,
        loading,
        buscarPessoasParaPreenchimento
      } = usePessoaAnttService();
      state.loadings.push(loading);
      buscarPessoasParaPreenchimento(termo, props.cliente?.idCliente ?? null)
        .then(() => {
          removeLoading(loading);
          state.resultados = (data.value as Array<PessoaAnttPayload>) ?? [];
          state.buscou = true;
        })
        .catch(() => removeLoading(loading));
    };

    const confirmSelection = (pessoa: PessoaAnttPayload) => {
      emit("confirm-selection", pessoa);
    };

    const cancelSelection = () => {
      emit("cancel-selection");
    };

    onMounted(() => {
      state.termo = props.termoInicial ?? "";
      state.stateReady = true;
      if (state.termo.trim().length >= MINIMO_BUSCA) {
        buscar();
      }
    });

    return {
      stateLoading,
      papelMinusculo,
      titulo,
      buscar,
      confirmSelection,
      cancelSelection,
      formatCpfCnpj,
      ...toRefs(state)
    };
  },
  props: {
    cliente: Object as PropType<ClientePayload>,
    /** Papel na tela que abriu: "Transportador", "Arrendatário"... */
    papel: String,
    termoInicial: String,
    parentLoading: Boolean
  },
  emits: ["confirm-selection", "cancel-selection"]
});
